import React from "react";

export default function SelfDeclaration() {
  return (
    <div>
      <h4 style={{textAlign: "center"}}>To Be Read Carefully And Agreed by Applicant</h4>
      <p>
        This certifies that this application was completed by me, and that all
        entries on it and information in it are true and complete to the best of
        my knowledge.
      </p>
      <p>
        I authorize to make such investigations and inquiries of my personal,
        employment, financial or medical history and other related matters as
        may be necessary in arriving at an employment decision. I hereby release
        employers, schools or persons from all liability in responding to
        inquiries in connection with my application.
      </p>
      <p>
        In the event of my employment, I understand that false or misleading
        information given in my application or interview(s) may result in
        discharge. I understand, also, that I am required to abide by all rules
        and regulations of, as permitted by Law.
      </p>
      <p>
        I understand that information I provide regarding current and previous
        employers may be used and those employers will be contacted, for the
        purpose of investigating my safety performance history as required by
        FMCSA 391.23 and I understand that I have the right to:
      </p>
      <p>
        <i>Review information provided by previous employers:</i>
      </p>
      <p>
        <i>
          Have Errors in the information corrected by previous employers and for
          those previous employers to resend the corrected information.
        </i>
      </p>
      <p>
        <i>
          Have a rebuttal statement attached to the alleged erroneous
          information, if the previous employer and I can't agree on the
          accuracy of the statement.
        </i>
      </p>
    </div>
  );
}
